import { Fonts } from 'components/base-ui'
import styled from 'styled-components'
import ModalConfirm from 'components/base-ui/ModalConfirm'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  isOpen: boolean
  isLoading: boolean
  onRequestClose: () => void
  onAccept: () => void
}

const ModalFinishEating: FC<Props> = ({ isOpen, isLoading, onRequestClose, onAccept }) => {
  const { t } = useTranslation()
  return (
    <ModalConfirm
      testId="finishEatingModalConfirm"
      isOpen={isOpen}
      isLoading={isLoading}
      hideCloseButton={false}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={false}
      buttonWidth="100%"
      btnAccept={{
        outline: false,
        content: t('buffet.modal.finishEating.confirm'),
        isProcessing: isLoading,
        onClick: onAccept,
      }}
      btnCancel={{
        outline: true,
        content: t('buffet.modal.finishEating.cancel'),
        isProcessing: false,
        onClick: onRequestClose,
      }}
    >
      <ModalContent>
        <Fonts.H2>{t('buffet.modal.finishEating.title')}</Fonts.H2>
        <Fonts.BaseTitleRegular>{t('buffet.modal.finishEating.description')}</Fonts.BaseTitleRegular>
      </ModalContent>
    </ModalConfirm>
  )
}

export default ModalFinishEating

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${({ theme }) => theme.spacing.XS};
  padding-top: ${({ theme }) => theme.spacing.XL};
  padding-bottom: ${({ theme }) => theme.spacing['3XL']};
  text-align: center;
`
